import React from 'react';
import PageTitle from 'modules/common/components/PageTitle';
import AppBannerLayout from 'modules/partial/BannerLayout';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import SendCode from './send-code';
import VerifyCode from './verify-code';

function ForgotPassword() {
  const { path } = useRouteMatch();

  return (
    <>
      <PageTitle title="Forgot Password | Manila E-Citizen" />
      <AppBannerLayout>
        <div className="flex flex-col justify-center">
          <div className="my-12">
            <Switch>
              <Route path={`${path}/verify/:type`} component={VerifyCode} />
              <Route path={`${path}`} component={SendCode} />
            </Switch>
          </div>
        </div>
      </AppBannerLayout>
    </>
  );
}
ForgotPassword.defaultProps = {};

ForgotPassword.propTypes = {};

export default ForgotPassword;
